import { alpha, styled, useTheme, Box } from "@mui/material";
import { forwardRef, JSX, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TreeItem,
  TreeItem2,
  TreeItem2Content,
  TreeItem2DragAndDropOverlay,
  TreeItem2GroupTransition,
  TreeItem2IconContainer,
  TreeItem2Label,
  TreeItem2Props,
  TreeItem2Provider,
  TreeItem2Root,
  TreeItem2SlotProps,
  useTreeItem2,
  UseTreeItem2ContentSlotOwnProps,
} from "@mui/x-tree-view";
import clsx from "clsx";
import { TreeItem2Icon } from "@mui/x-tree-view/TreeItem2Icon";
// import CustomMenu from "../../customMenu";

interface CustomTreeItemProps {
  id: string;
  itemId: string;
  title: string;
  tipo: "PAI" | "FILHO";
  subPages?: { itemId: string; path: string }[];
  hideTitle?: boolean;
  path?: string;
  icon?: JSX.Element;
  children?: React.ReactNode;
  disabled?: boolean;
  open?: boolean;
  closeOnClickItem?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedItems?: React.Dispatch<React.SetStateAction<string[] | undefined>>;
  setExpandedItems?: React.Dispatch<React.SetStateAction<string[] | undefined>>;
  selectedItems?: string[];
  expandedItems?: string[];
  paternal?: { id: string; title: string };
  selected?: boolean;
  openInNewTab?: boolean;
  apiRef?: any;
  setTitlePage?: React.Dispatch<React.SetStateAction<string>>;
  setLink?: React.Dispatch<React.SetStateAction<string>>;
  nivel: number;
  usePath?: boolean;
}
const CustomTreeItem = forwardRef(function CustomTreeItem(
  props: CustomTreeItemProps,
  ref: React.Ref<HTMLLIElement>,
): JSX.Element {
  const {
    id,
    itemId,
    title,
    tipo,
    hideTitle = false,
    path,
    icon,
    subPages,
    disabled,
    open = true,
    closeOnClickItem = false,
    setOpen = () => {},
    setSelectedItems = () => {},
    setExpandedItems = () => {},
    selectedItems = [],
    expandedItems = [],
    paternal = null,
    children = null,
    openInNewTab = false,
    apiRef,
    setTitlePage = () => {},
    setLink = () => {},
    nivel = 0,
    usePath = false,
    ...other
  } = props;

  const theme = useTheme();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLDivElement) | null
  >();
  const openMenu = Boolean(anchorEl);

  const handleFatherClick = () => {
    setExpandedItems((prev) => {
      if (prev?.includes(itemId)) {
        return prev.filter((item) => item !== itemId);
      }
      return [...(prev || []), itemId];
    });
  };
  const handleChildrenClick = () => {
    // if (openInNewTab) {
    //   window.open(path, "_blank");
    //   return;
    // }

    setSelectedItems((prev) => {
      // if (prev?.includes(itemId)) {
      //   //return prev.filter((item) => item !== itemId);
      //   return [];
      // }

      if (tipo === "FILHO" && paternal?.id) {
        return [itemId, paternal.id];
      }
      return [itemId];
    });

    if (path) {
      if (closeOnClickItem) setOpen(false);

      if (usePath) {
        navigate(path);
        setTitlePage(hideTitle ? "" : title);
        setLink(path);
      } else {
        navigate(`dashboard/${id}`);
        setTitlePage(hideTitle ? "" : title);
        setLink(`dashboard/${id}`);
      }
    }
  };

  const {
    getRootProps,
    getContentProps,
    getIconContainerProps,
    //getCheckboxProps,
    getLabelProps,
    getGroupTransitionProps,
    status,
  } = useTreeItem2({
    id,
    itemId,
    children,
    label: title,
    disabled,
    rootRef: ref,
  });

  const styles = {
    contentFather: {
      display: "flex",
      marginY: "3px",
      marginX: 0,
      minHeight: "40px",
      height: "auto",
      color: "#919EAB",
      "&:hover": {
        backgroundColor: alpha(theme.palette.text.disabled, 0.1),
      },
      ...(status.expanded && {
        color: "#FFFFFF",
        "&:hover": {
          backgroundColor: alpha(theme.palette.text.disabled, 0.2),
        },
      }),
      ...(status.expanded &&
        status.selected && {
          color: "#FFFFFF",
          backgroundColor: alpha(theme.palette.text.primary, 0.1),
          "&:hover": {
            backgroundColor: alpha(theme.palette.text.primary, 0.2),
          },
        }),
    },

    contentChildren: {
      display: "flex",
      marginY: "3px",
      marginX: 0,
      minHeight: "40px",
      height: "auto",
      color: "#919EAB",
      "&:hover": {
        backgroundColor: alpha(theme.palette.text.disabled, 0.1),
      },
      ...(status.selected && {
        color: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.primary.main, 0.1),
        "&:hover": {
          backgroundColor: alpha(theme.palette.primary.main, 0.2),
        },
      }),
    },
    contentBox: {
      flexGrow: 1,
      display: "flex",
      gap: "10px",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    groupTransition: {
      marginLeft: 2,
      borderLeft: `1px solid ${
        status.expanded && status.selected
          ? theme.palette.primary.main
          : theme.palette.text.disabled
      }`,
    },
  };

  return (
    <TreeItem2Provider itemId={itemId}>
      <TreeItem2Root {...getRootProps(other)}>
        <TreeItem2Content
          {...getContentProps({
            className: clsx("content", {
              expanded: status.expanded,
              selected: status.selected,
              focused: status.focused,
            }),
          })}
          sx={tipo === "PAI" ? styles.contentFather : styles.contentChildren}
          onClick={tipo === "PAI" ? handleFatherClick : handleChildrenClick}
          onMouseEnter={(e) => {
            setAnchorEl(e.currentTarget);
          }}
          onMouseLeave={(e) => {
            setAnchorEl(null);
            apiRef?.current?.focusItem(e, selectedItems[0]);
          }}
        >
          <Box sx={styles.contentBox}>
            {icon}
            {open ? <TreeItem2Label {...getLabelProps()} /> : null}
          </Box>
          {open && (
            <TreeItem2IconContainer {...getIconContainerProps()}>
              <TreeItem2Icon status={status} />
            </TreeItem2IconContainer>
          )}
          {/* <CustomMenu
              anchorEl={anchorEl}
              openMenu={openMenu && !open}
              setAnchorEl={setAnchorEl}
              {...props}
            /> */}
        </TreeItem2Content>
        {children && open && (
          <TreeItem2GroupTransition
            {...getGroupTransitionProps()}
            sx={styles.groupTransition}
          />
        )}
      </TreeItem2Root>
    </TreeItem2Provider>
  );
});
export default CustomTreeItem;
